import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import HeaderAfterLogin from "../HeaderAfterLogin";
import SidebarMobile from "../SidebarMobile";
import YearSelectionDialog from "../YearSelectionDialog";
import {getAccessToken, getSchoolYear} from "../../utils/authority";
import {isSystemScope} from "../../utils/common";
import {toast} from "react-toastify";
import UserController from "../../services/system/user/user-controller";
class Layout extends React.Component {
    static propTypes = {
        isFetching: PropTypes.bool,
        isCommonFetching: PropTypes.bool,
    };

    constructor(...args) {
        super(...args);
        this.state = {
            modalLogin: false,
            modalSignup: false,
            modalSignUpMember: false,
            haveToken: false,
            signupInfo: null,
            modalWarningInfo: false,
            listCategory: [],
            modalLockAccount: false,
            sidebarMobile: false,
            isUpdate: false,
            showYearSelectionDialog: false
        };
    }
    componentDidMount() {
        let token = getAccessToken();
        if (token) {
            this.setState({haveToken: true});

            // Admin tổng không thuộc trường nào nên không có năm học phiên: mỗi trường có
            // bản ghi `year` riêng, cùng năm 2026-2027 là yearId=2 ở trường này, yearId=8 ở
            // trường kia. Ép chọn một yearId ở đây là vô nghĩa — năm học đi vào như tham số
            // của từng báo cáo (ba-shared/api-contracts/system-report/README.md).
            if (!isSystemScope()) {
                // Kiểm tra nếu chưa chọn năm học thì hiện dialog
                const yearId = getSchoolYear();
                if (!yearId || yearId === 'undefined' || yearId === 'null') {
                    this.setState({showYearSelectionDialog: true});
                }
            }
        }
    }
    setSignupInfo = (signupInfo) => {
        this.setState({signupInfo}, () => {
            this.modalSignupClose();
            this.onOpenModalOtp()
        })
    };
    onOpenModalOtp = (event) => {
        // event.preventDefault();
        this.setState({modalOtp: true});
    };
    modalSignupClose = () => this.setState({modalSignup: false});
    showModalWarningInfo = () => {
        this.setState({modalWarningInfo: true});
    };
    showModalWarningEmail = () => {
        this.setState({modalWarningEmail: true});
    };

    saveOtp = (tokenForgotPass, otp) => {
        this.setState({
            tokenForgotPass,
            otp,
        })
    };
    toggleSidebarMobile = () => {
        let sidebar = this.state.sidebarMobile
        this.setState({
            sidebarMobile: !sidebar
        })
    };

    // Xử lý khi không có năm học nào trong hệ thống
    handleNoYears = () => {
        this.setState({ showYearSelectionDialog: false });
    };


    render() {
        return (
            <div id="mainContainer">
                <div className="loading"
                     style={this.props.isFetching || this.props.isCommonFetching ? {display: 'block'} : {display: 'none'}}>
                    <div className="lds-dual-ring"></div>
                </div>

                {this.state.haveToken && <HeaderAfterLogin listCategory={this.state.listCategory}
                                                          showModalWarningInfo={this.showModalWarningInfo}
                                                          showModalWarningEmail={this.showModalWarningEmail} toggleSidebarMobile={this.toggleSidebarMobile}/>}
                <div className="content-wrapper">
                    {this.props.children}
                </div>
                {/*</div>*/}

                <SidebarMobile show={this.state.sidebarMobile}
                               toggleSidebarMobile={this.toggleSidebarMobile}
                               onOpenModalLogin={this.onOpenModalLogin}
                               onOpenModalSignup={this.onOpenModalSignup}/>

                {/* Dialog chọn năm học - hiển thị khi chưa chọn năm học */}
                {this.state.showYearSelectionDialog && <YearSelectionDialog onNoYears={this.handleNoYears} />}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        // isAuthenticated: state.auth.isAuthenticated,
        isFetching: state.reducer.isFetching,
        // isCommonFetching: state.common.isFetching,
    };
}

export default connect(mapStateToProps)(Layout);
